
const HowWeHelpSection = () => {
  const pillars = [
    {
      icon: 'ri-ear-line',
      title: 'Listen First',
      description: 'We take time to understand your goals, concerns, and what matters most about your business legacy.'
    },
    {
      icon: 'ri-scales-line',
      title: 'Evaluate Fairly',
      description: 'Decades of experience with real businesses means our valuations are honest, transparent, and rooted in your true results.'
    },
    {
      icon: 'ri-arrow-right-line',
      title: 'Transition Smoothly',
      description: 'We manage every detail of the transition process to minimize disruption to your operations and team.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Protect Your Legacy',
      description: 'Your business values, employee relationships, and customer trust remain intact under our stewardship.'
    }
  ];

  return (
    <section className="py-20 bg-soft-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            How We Help
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven approach ensures your business transition preserves what you've built while securing your financial future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 flex items-center justify-center bg-[#C9A227] rounded-full mx-auto mb-6 group-hover:bg-navy transition-colors duration-300">
                <i className={`${pillar.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="font-playfair text-xl font-semibold text-navy mb-4">
                {pillar.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelpSection;
